/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardControlKey: {
  name: 'keyboard-control-key';
  data: string;
} = {
  name: 'keyboard-control-key',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m5 12 1.41 1.41L12 7.83l5.59 5.58L19 12l-7-7z"/></svg>`
};
